import React, { FC, Fragment } from 'react'
import { ArrowRight } from '../../../../constants/svg'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type Props = {
  platformDiagramData: any
}

export const BottomItems: FC<Props> = ({ platformDiagramData }) => (
  <div className="PlatformDiagram__Bottom-Items">
    <Typography className="PlatformDiagram__Bottom-Heading" type="header5">
      {platformDiagramData.itemDescription}
    </Typography>

    <div className="PlatformDiagram__Bottom-Grid">
      {platformDiagramData.items?.map((iconText: any, n: number) => {
        const imgSrc =
          iconText.colorIcon && iconText.colorIcon.file.url ? iconText.colorIcon.file.url : ''

        const imgAlt = iconText.seo || 'UiPath Icon'
        const iconTextHeading = iconText.title || ''
        const showArrow = n !== platformDiagramData.items.length - 1

        return (
          <Fragment key={`iconTextItem--${n}`}>
            <div className="PlatformDiagram__Icon-Text">
              {imgSrc && (
                <div className="PlatformDiagram__Icon-Text-Image-Container">
                  <WrapperImage
                    className="PlatformDiagram__Icon-Text-Image"
                    src={imgSrc}
                    alt={imgAlt}
                    height={64}
                    width={64}
                    threshold={650}
                  />
                </div>
              )}

              <Typography className="PlatformDiagram__Icon-Text-Copy" type="label">
                {iconTextHeading}
              </Typography>
            </div>

            {!showArrow && <ArrowRight />}
          </Fragment>
        )
      })}
    </div>
  </div>
)
